module.exports = __webpack_public_path__ + "img/xmdx.02a14498.png";